import styled from 'styled-components'

export const FormWrapper = styled.div`
  background-color: #1A1A1Acd ;
  max-width:650px;
  width:85%;
  min-height:200px;
  margin-top:5vh;
  padding: 1% 0;
  display:flex;
  flex-direction: column;
  border: 3px solid #fff;
`;